module.exports = __webpack_public_path__ + "img/5.f65c7094.jpg";